import React from 'react';

import { AudioVisualizerData } from '../types';

interface AudioVisualizerProps {
  audioData: AudioVisualizerData;
  isActive: boolean;
}

export const AudioVisualizer: React.FC<AudioVisualizerProps> = ({ audioData, isActive }) => {
  const { frequencies } = audioData;
  
  // Create bars for frequency visualization
  const bars = Array.from({ length: 20 }, (_, i) => {
    const frequency = frequencies[i * 5] || 0;
    const height = Math.max(frequency / 255 * 100, 3);
    return height;
  });
  
  return (
    <div className="flex items-end justify-center gap-1 h-full">
      {bars.map((height, index) => (
        <div
          key={index}
          className="audio-bar w-1 transition-all duration-150"
          style={{ 
            height: `${height}%`,
            opacity: isActive ? 0.6 + (height / 100) * 0.4 : 0.3
          }}
        />
      ))}
    </div>
  );
};